/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLocation } from "react-router-dom";
import { getAnonymousID } from "redline-client-sdk";

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    gtag: any;
    isNativeApp?: boolean;
    NativeFeatures?: {
      FirebaseAnalytics?: boolean;
      FacebookEvents?: boolean;
      AppsFlyer?: boolean;
      InAppReview?: boolean;
      NotificationSchedule?: boolean;
      PushNotificationStatus?: boolean;
    };
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    ReactNativeWebView?: any;
  }
}

interface ITrackingEventPayload {
  eventName: string;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  payload?: any;
}

export const useGoogleAnalytics = () => {
  const location = useLocation();

  function trackGA({ eventName, payload }: ITrackingEventPayload) {
    const isDebtSimulated = eventName === "user_authenticated_with_debt";
    const isNegativeDebtSimulated =
      eventName === "user_authenticated_with_negative_debt";
    const shouldDispatchBothContainers =
      isDebtSimulated || isNegativeDebtSimulated;

    // @ts-ignore
    if (window?.bridge?.isWebViewBridgeAvailable) {
      // @ts-ignore
      window.bridge.analyticsFirebaseLogEvent(`app_${eventName.replace(/-/g, "_")}`, payload);
      if (!shouldDispatchBothContainers) return;
    }

    if (!window?.gtag) {
      return;
    }

    const anonymousId = getAnonymousID();
    const url = location.pathname;

    const safePayload = payload
      ? { ...payload, anonymousId, url }
      : { anonymousId, url };

    return window.gtag("event", eventName, safePayload);
  }

  return { trackGA };
};
